import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { VexPopoverService } from "@vex/components/vex-popover/vex-popover.service";
import { ToolbarUserDropdownComponent } from "./toolbar-user-dropdown/toolbar-user-dropdown.component";
import { MatIconModule } from "@angular/material/icon";
import { MatRippleModule } from "@angular/material/core";
import { ProfileService } from "src/app/services/profile.service";
import { Profile } from "src/app/interfaces";
import { NgIf } from "@angular/common";

@Component({
  selector: "vex-toolbar-user",
  templateUrl: "./toolbar-user.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatRippleModule, MatIconModule, NgIf],
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean = false;
  profile: Profile = <Profile>{};

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private profileService: ProfileService,
  ) {
    this.profileService.getProfile$().subscribe((profile) => {
      this.profile = profile;
      this.cd.markForCheck();
    });
  }

  ngOnInit() {}

  profileDisplayName(): string {
    return this.profileService.getProfileDisplayName();
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: "center",
          originY: "top",
          overlayX: "center",
          overlayY: "bottom",
        },
        {
          originX: "end",
          originY: "bottom",
          overlayX: "end",
          overlayY: "top",
        },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
